export const environment = {
  "production": false,
  "apiEndPoint": "https://demo.invonow.com",
  "appVersion": "1.0"
};
